var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIsometricMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "megaphone (3) 1",
    clipPath: "url(#clip0_2_25568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.91162 9.09277L3.64596 16.0718C3.66459 16.2489 3.76689 16.4065 3.92115 16.4955L4.66697 16.9261C4.84568 17.0293 5.06588 17.0293 5.24459 16.9261L6.40955 16.2536C6.58174 16.1541 6.68783 15.9704 6.68783 15.7716V10.3053L2.91162 9.09277Z",
    fill: "url(#paint0_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.05865 10.4902L3.30252 10.631C4.88705 11.5436 5.9201 12.8984 6.52092 14.6255L6.68783 15.1052V10.3052L2.91162 9.09277L3.05865 10.4902Z",
    fill: "url(#paint1_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.70508 1.59215L3.70402 1.59149L3.70395 1.5916C3.31406 1.40348 2.82094 1.44071 2.28414 1.75059C1.02266 2.47895 0 4.43289 0 6.11485C0 7.05512 0.319766 7.71102 0.821992 7.97969L0.82168 7.98039L3.30254 9.4127L6.28605 3.07774C6.28609 3.07778 3.78305 1.62989 3.70508 1.59215Z",
    fill: "url(#paint2_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6179 3.86727C9.22845 4.1409 7.78974 3.92785 6.54036 3.26938C6.12145 2.86133 5.50095 2.80738 4.80782 3.20758C3.54634 3.9359 2.52368 5.88985 2.52368 7.57184C2.52368 8.48496 2.82548 9.12938 3.3029 9.41195L3.30251 9.41278C4.88704 10.3254 5.92009 11.6802 6.52091 13.4073L7.557 16.3854L15.284 2.94832L10.6179 3.86727Z",
    fill: "url(#paint3_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.0067 3.9787L16.1943 2.94385C15.2122 2.39631 13.9401 2.45671 12.5494 3.25963C9.44111 5.05421 6.92139 9.8687 6.92139 14.0131C6.92139 16.3589 7.72912 17.9863 8.9935 18.6324L10.7228 19.6261L18.0067 3.9787Z",
    fill: "url(#paint4_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20 8.55703C20 4.41265 17.4802 2.50777 14.3719 4.30234C11.2637 6.09691 8.7439 10.9114 8.7439 15.0557C8.7439 19.2001 11.2637 21.105 14.3719 19.3104C17.4802 17.5159 20 12.7014 20 8.55703Z",
    fill: "url(#paint5_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.0086 13.3614C19.5194 9.81573 19.118 6.24852 17.1121 5.39382C15.1061 4.53911 12.2553 6.72058 10.7445 10.2663C9.23375 13.8119 9.63516 17.3792 11.6411 18.2339C13.647 19.0886 16.4979 16.9071 18.0086 13.3614Z",
    fill: "#E9E5F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.3218 5.20428C15.7309 5.17077 15.0698 5.34276 14.372 5.74569C11.8615 7.1951 9.82642 11.0836 9.82642 14.4308C9.82642 15.6833 10.1114 16.6826 10.5995 17.3668C11.1722 18.1695 16.5932 15.33 18.0067 11.4876C18.6083 9.85213 16.78 5.23026 16.3218 5.20428Z",
    fill: "url(#paint6_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.1277 12.0868L13.0461 13.7719L15.086 9.47804L12.1602 7.78882C11.236 9.01022 10.511 10.5339 10.1277 12.0868Z",
    fill: "url(#paint7_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.3218 5.20459C16.81 5.88881 17.095 6.88799 17.095 8.14049C17.095 11.4878 15.0599 15.3762 12.5494 16.8256C11.8515 17.2285 11.1905 17.4002 10.5996 17.3667C11.4161 18.511 12.8009 18.7742 14.372 17.8671C16.8825 16.4177 18.9176 12.5292 18.9176 9.18197C18.9176 6.76525 17.8566 5.29174 16.3218 5.20459Z",
    fill: "url(#paint8_linear_2_25568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M15.3234 12.1689C15.8388 10.9592 15.7018 9.74222 15.0175 9.45063C14.3331 9.15904 13.3605 9.90328 12.8451 11.1129C12.3297 12.3226 12.4666 13.5396 13.151 13.8312C13.8353 14.1228 14.8079 13.3785 15.3234 12.1689Z",
    fill: "#E9E5F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_25568",
    x1: 4.48154,
    y1: 13.0482,
    x2: 5.41924,
    y2: 13.0482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_25568",
    x1: 7.26186,
    y1: 10.3617,
    x2: 3.66221,
    y2: 12.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7662BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7662BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_25568",
    x1: 1.50648,
    y1: 7.35192,
    x2: 3.87867,
    y2: 3.09496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_25568",
    x1: 5.50974,
    y1: 10.4698,
    x2: 8.93247,
    y2: 4.54152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_25568",
    x1: 10.5847,
    y1: 12.0525,
    x2: 15.9782,
    y2: 2.71065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_25568",
    x1: 14.3719,
    y1: 22.2751,
    x2: 14.3719,
    y2: 3.57558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB2C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0732,
    stopColor: "#B3343F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    stopColor: "#DC5A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8056,
    stopColor: "#F6717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_25568",
    x1: 15.7754,
    y1: 8.45166,
    x2: 12.3336,
    y2: 14.4129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_25568",
    x1: 12.0818,
    y1: 11.5997,
    x2: 13.2546,
    y2: 9.56835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5BAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_25568",
    x1: 18.2037,
    y1: 7.56631,
    x2: 11.1465,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#802129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4757"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_25568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.731445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIsometricMegaphone);
export default __webpack_public_path__ + "static/media/icon-isometric-megaphone.39d2f9252cfa0e4eeef1e1b5f7309be0.svg";
export { ForwardRef as ReactComponent };